import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useLocation } from 'react-router-dom';
export const Sidebar = ({ isCollapsed }) => {
    const location = useLocation();
    const navigation = [
        { name: 'Dashboard', href: '/', icon: '📊' },
        { name: 'Scheduler', href: '/scheduler', icon: '📋' },
        { name: 'Workflow Runs', href: '/scheduler/workflows', icon: '⚙️', indent: true },
        { name: 'Agents', href: '/agents', icon: '🤖' },
        { name: 'Workflow Defs', href: '/agents/workflows', icon: '🔗', indent: true },
        { name: 'Workflow Builder', href: '/workflows/builder', icon: '🏗️', indent: true },
        { name: 'Templates', href: '/workflows/templates', icon: '📑', indent: true },
        // Baz Skills Integration - Backend not implemented yet (Issue #160)
        // { name: 'Baz Skills', href: '/baz/skills', icon: '🎯' },
        // { name: 'Baz Agents', href: '/baz/agents', icon: '📦', indent: true },
        // { name: 'Baz Status', href: '/baz/status', icon: '💚', indent: true },
        { name: 'Users', href: '/users', icon: '👥' },
        { name: 'Model Tiers', href: '/model-tiers', icon: '🧠' },
        { name: 'Rebaseline', href: '/rebaseline', icon: '📐' },
        { name: 'Analytics', href: '/analytics/personality', icon: '📈' },
        { name: 'Moderation', href: '/moderation/conversations', icon: '🛡️' },
        { name: 'Reports', href: '/moderation/reports', icon: '📮', indent: true },
        // GitHub Issue Tracker - Backend not implemented yet (Issue #159)
        // { name: 'Issue Tracker', href: '/issues', icon: '🐛' },
        // { name: 'Dashboard', href: '/issues/dashboard', icon: '📊', indent: true },
        { name: 'Audit Log', href: '/audit', icon: '📜' },
    ];
    return (_jsx("aside", { className: `bg-secondary-900 text-white transition-all duration-300 ${isCollapsed ? 'w-16' : 'w-64'}`, children: _jsx("nav", { className: "mt-8 px-2", children: navigation.map((item) => {
                const isActive = location.pathname === item.href;
                const indent = 'indent' in item && item.indent;
                return (_jsxs(Link, { to: item.href, className: `flex items-center px-4 py-3 mb-2 rounded-lg transition-colors ${indent ? 'ml-4' : ''} ${isActive
                        ? 'bg-primary-600 text-white'
                        : 'text-gray-300 hover:bg-secondary-800 hover:text-white'}`, children: [_jsx("span", { className: "text-xl", children: item.icon }), !isCollapsed && _jsx("span", { className: "ml-3 font-medium", children: item.name })] }, item.name));
            }) }) }));
};
